import { render, staticRenderFns } from "./diary.vue?vue&type=template&id=fbd67f74&scoped=true&"
import script from "./diary.vue?vue&type=script&lang=js&"
export * from "./diary.vue?vue&type=script&lang=js&"
import style0 from "./diary.vue?vue&type=style&index=0&id=fbd67f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd67f74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
